import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext';
import { useNotificationContext } from '../../context/NotificationContext';
import { ApiService } from '../../services/api';
import { CameraImageResponse } from '../../types';
import { OutsSelection } from './components/OutsSelection';
import { PageLoadingSpinner } from './components/PageLoadingSpinner';

export const OutsSelectionPage: React.FC = () => {
  const { imageId } = useParams<{ imageId: string }>();
  const { token } = useAuthContext();
  const { showErrorToast } = useNotificationContext();
  const [cameraImage, setCameraImage] = useState<CameraImageResponse | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchCameraImage = useCallback(async () => {
    if (!imageId) return;

    setIsLoading(true);
    setCameraImage(null);
    try {
      const cacheKey = `camera-image-${imageId}`;
      const cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        setCameraImage(JSON.parse(cached));
        return;
      }

      const data = await ApiService.fetchCameraImage(token, imageId, {
        countActiveEmbeddings: true,
      });
      setCameraImage(data);
    } catch (err) {
      showErrorToast('Failed to fetch camera image');
    } finally {
      setIsLoading(false);
    }
  }, [imageId, token, showErrorToast]);

  useEffect(() => {
    fetchCameraImage();
  }, [fetchCameraImage]);

  if (!imageId) return null;

  if (isLoading) {
    return <PageLoadingSpinner message="Loading camera image..." fullScreen />;
  }

  if (!cameraImage) return null;

  return <OutsSelection key={imageId} imageId={imageId} cameraImage={cameraImage} />;
};

export default OutsSelectionPage;
